import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../../app/_services/app.service';
import { CommonService } from '../../../../app/_services/common.service';
import { DecryptPipe } from '../../../../app/auth/_services/encrypt-decrypt.pipe';
import { TranslateConfigService } from '../../../../app/theme/home/translateConfig.service';
import { MobileDetectionService } from '../../services/mobile-detection.service';
import { OrdersService } from '../../services/orders/orders.service';
import { DatePipe } from '@angular/common';
import { OverlayPanel } from 'primeng/overlaypanel';
import { NavService } from '../../../../app/_services/NavService.service';
import { ModalService } from '../../../../app/_services/modal.service';
const LNG_KEY = "SELECTED_LANGUAGE";
declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-report-header',
  templateUrl: './report-header.component.html',
  styleUrls: ['./report-header.component.scss']
})
// added by priya - 03/03/2025
export class ReportHeaderComponent implements OnInit {

  selectedLang: any;
  static that: ReportHeaderComponent;
  CurAccYearData: any;
  LastAccYearData: any;
  TransactionType: any = '';
  ModalType: any = '';
  @Output() DateChange = new EventEmitter<string>();
  @Output() CompanyChnage = new EventEmitter<string>();
  @ViewChild('op') dateModal: OverlayPanel;
  @ViewChild('short') ShortcutKeys: OverlayPanel;
  TenantId: any;
  UserId: any;
  CompanyId: any;
  TenantUsers: any;
  CompanyIdForCookie: any;
  StartDate: any;
  EndDate: any;
  DateRange: any;
  // DateRange = 'CurrentFinancialYear'
  currentstartYear: any;
  currentendYear: any;
  laststartYear: any;
  lastendYear: any;
  @Output() onReportDownloadClickOutput = new EventEmitter();
  @Input() IsReportDownload: boolean = false;
  @Input() IsReportPrint: boolean = false;
  data: any = {};

  FromDate: any = {
    lable: '',
    formControlName: 'StartDate',
    dataField: 'StartDate',
    isRequired: false,
    type: "text",
    placeholder: 'Select Start Date'
  };

  ToDate: any = {
    lable: '',
    formControlName: 'EndDate',
    dataField: 'EndDate',
    isRequired: false,
    type: "text", 
    placeholder: 'Select End Date'
  };

  constructor(
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private translate: TranslateService,
    private commonService: CommonService,
    private service: TranslateConfigService,
    private mobileDetectionService: MobileDetectionService,
    private orderService: OrdersService,
    private router: Router,
    public datepipe: DatePipe,
    private _navService: NavService,
    private modalService: ModalService
  ) { 
    ReportHeaderComponent.that = this;
    let language = this.translate.getBrowserLang();
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service.setLanguage(value);
      this.selectedLang = value;
    }
    let val = localStorage.getItem(LNG_KEY);
  }

  ngOnInit() {
    this.TenantId = JSON.parse(this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId"))));
    this.UserId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    this.GetUserCompany();
    this.GetCurrentAccYear();
    this.GetLastAccYear();
    $("#DateRange").val("CurrentFinancialYear");
    this.ShowHelpMenu();
    
    setTimeout(() => {
      let daterange = localStorage.getItem("dateRange")
      this.DateRange = daterange || 'CurrentFinancialYear';
      if(this.DateRange == 'CurrentFinancialYear'){
        this.data.StartDate = this.formatDate(new Date(this.currentstartYear));
        this.data.EndDate = this.formatDate(new Date(this.currentendYear));
        localStorage.setItem('StartDate', this.data.StartDate);
        localStorage.setItem('EndDate', this.data.EndDate);
        localStorage.setItem('dateRange', 'CurrentFinancialYear');
      } else {
        let startdate = localStorage.getItem('StartDate');
        let enddate = localStorage.getItem('EndDate')
        this.data.StartDate = this.formatDate(new Date(startdate));
        this.data.EndDate = this.formatDate(new Date(enddate));
      }
    }, 1000);
  }

  simulateTabKey() {
    const event = new KeyboardEvent('keydown', {
      key: 'Tab',
      code: 'Tab',
      bubbles: true
    });
  }

  OpenModal(event: Event) {
    ReportHeaderComponent.that.dateModal.show(event);
    this.modalService.openDateModal();
    setTimeout(() => {
      const modalElement = document.querySelector('.ui-overlaypanel'); // Ensure modal is open
      if (modalElement) {
        const inputElement = modalElement.querySelector('input, select, textarea') as HTMLElement; // Find first focusable element
        if (inputElement) {
          inputElement.focus(); // Set focus to first input field
          this.simulateTabKey(); // Simulate Tab key press
        }
      }
    }, 500);
  }

  CloseModal() {
    this.dateModal.hide();
    this.modalService.closeDateModal();
  }

  OpenShortcutKeys(event: Event) {
    ReportHeaderComponent.that.ShortcutKeys.show(event);
    this.modalService.openShortcutModal();
    this.TransactionType = 'Sidebar';
    this.ModalType = 'A';
  }

  CloseShortcutKeys() {
    this.ShortcutKeys.hide();
    this.modalService.closeShortcutModal();
  }

  // for getting company detail
  GetUserCompany() {
    this._appService.GetByTwoId("Company", "GetUserCompany", this.TenantId, this.UserId).subscribe((response: any) => {
      this.TenantUsers = response.data; //FOR DROPDOWN
      this.TenantUsers.forEach((element) => {
        if (element.DefaultCompanyId == element.Id) {
          this.CompanyIdForCookie = element;
          $("#UserCompany").val(element.Id);
        }
        if (localStorage.getItem("ChnageCompnayId") == "undefined") {
          localStorage.setItem("ChnageCompnayId", JSON.stringify(this.CompanyIdForCookie));
        }
        if (
          JSON.parse(localStorage.getItem("ChnageCompnayId")) == null &&
          JSON.parse(localStorage.getItem("ChnageCompnayId")) == undefined
        ) {
          localStorage.setItem("ChnageCompnayId", JSON.stringify(this.CompanyIdForCookie));
        } else {
          this.TenantUsers.forEach((element) => {
            if (JSON.parse(localStorage.getItem("ChnageCompnayId")).Id !=undefined) {
              if (JSON.parse(localStorage.getItem("ChnageCompnayId")).Id == element.Id) {
                this.CompanyIdForCookie = element;
              }
            }
          });
        }
        // if (localStorage.getItem("ChnageCompnayId") == "undefined") {
        //   localStorage.setItem("ChnageCompnayId", JSON.stringify(this.CompanyIdForCookie));
        // }
        // if (
        //   JSON.parse(localStorage.getItem("ChnageCompnayId")) == null &&
        //   JSON.parse(localStorage.getItem("ChnageCompnayId")) == undefined
        // ) {
        //   localStorage.setItem("ChnageCompnayId", JSON.stringify(this.CompanyIdForCookie));
        // } else {
        //   this.TenantUsers.forEach((element) => {
        //     if (JSON.parse(localStorage.getItem("ChnageCompnayId")).Id !=undefined) {
        //       if (JSON.parse(localStorage.getItem("ChnageCompnayId")).Id == element.Id) {
        //         this.CompanyIdForCookie = element;
        //       }
        //     }
        //   });
        // }
      
      });
    },
    (err) => {
      this.toastr.error(this.translate.instant("MESSAGES.GetError"));
    });
  }

  // getting financial year
  GetCurrentAccYear() {
    var today = this.datepipe.transform(new Date(), "yyyy-MM-dd");
    this._appService.GetByTwoId("Common", "AC_GetAccountingPeriodOfCompany", this.CompanyId, today).subscribe((response: any) => {
      this.CurAccYearData = response;
      if (response) {
        let yearRange = response.split("-"); // Extract years
        if (yearRange.length === 2) {
          this.currentstartYear = `01-Apr-${yearRange[0]}`; // Start Date (April 1st)
          this.currentendYear = `31-Mar-${yearRange[1]}`; // End Date (March 31st)

          // localStorage.removeItem('StartDate');
          // localStorage.removeItem('EndDate');
          let startdate = localStorage.getItem('StartDate');
          let enddate = localStorage.getItem('EndDate')
          if(startdate == undefined || enddate == undefined){
            localStorage.setItem('StartDate', this.currentstartYear);
            localStorage.setItem('EndDate', this.currentendYear);
          }

          // this.data.StartDate = this.currentstartYear;
          // this.data.EndDate = this.currentendYear;
        }
      }
    },
    (err) => {
      this.toastr.error(this.translate.instant("MESSAGES.GetError"));
    });
  }

  GetLastAccYear() {
    var today = this.datepipe.transform(new Date(new Date().setFullYear(new Date().getFullYear() - 1)), "yyyy-MM-dd");
    this._appService.GetByTwoId("Common", "AC_GetAccountingPeriodOfCompany", this.CompanyId, today).subscribe((response: any) => {
      this.LastAccYearData = response;
      if (response) {
        let yearRange = response.split("-"); // Extract years
        if (yearRange.length === 2) {
          this.laststartYear = `01-Apr-${yearRange[0]}`; // Start Date (April 1st)
          this.lastendYear = `31-Mar-${yearRange[1]}`; // End Date (March 31st)
        }
      }
    },
    (err) => {
      this.toastr.error(this.translate.instant("MESSAGES.GetError"));
    });
  }

  // date will change according to date range
  ChangeDate(event: any) {
    let value = event.target.value;
    let today = new Date();

    if (value === 'LastWeek') {
      let lastSunday = new Date();
      lastSunday.setDate(today.getDate() - today.getDay()); // Get last Sunday
      let lastMonday = new Date(lastSunday);
      lastMonday.setDate(lastSunday.getDate() - 6); // Get last Monday
      this.data.StartDate = this.formatDate(lastMonday);
      this.data.EndDate = this.formatDate(lastSunday);
      localStorage.setItem('dateRange', 'LastWeek');
    } 
    else if (value === 'LastMonth') {
      let firstDay = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      let lastDay = new Date(today.getFullYear(), today.getMonth(), 0);
      this.data.StartDate = this.formatDate(firstDay);
      this.data.EndDate = this.formatDate(lastDay);
      localStorage.setItem('dateRange', 'LastMonth');
    } 
    else if (value === 'CurrentMonth') {
      let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      let lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      this.data.StartDate = this.formatDate(firstDay);
      this.data.EndDate = this.formatDate(lastDay);
      localStorage.setItem('dateRange', 'CurrentMonth');
    } 
    else if (value === 'CurrentFinancialYear') {
      console.log('this.data', this.data)
      this.data.StartDate = this.formatDate(new Date(this.currentstartYear));
      this.data.EndDate = this.formatDate(new Date(this.currentendYear));
      localStorage.setItem('dateRange', 'CurrentFinancialYear');
    } 
    else if (value === 'LastFinancialYear') {
      this.data.StartDate = this.formatDate(new Date(this.laststartYear));
      this.data.EndDate = this.formatDate(new Date(this.lastendYear));
      localStorage.setItem('dateRange', 'LastFinancialYear');
    }

    console.log("Start Date:", this.StartDate);
    console.log("End Date:", this.EndDate);
  }

  // formats the date in dd-MMM-yyyy
  formatDate(date: Date): string {
    // return this.datepipe.transform(date, 'dd-MMM-yyyy');
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const day = date.getDate().toString().padStart(2, '0'); // Ensure two-digit day
    const month = months[date.getMonth()]; // Get short month name
    const year = date.getFullYear(); // Get full year

    return `${day}-${month}-${year}`;
  }

  getChangedValue(value, data) {
    if (data.dataField == 'StartDate') {
      if (value != null) {
        this.data[this.FromDate.dataField] = value;
        this.DateRange = '';
        localStorage.setItem('dateRange', this.DateRange);
      }
    }
    if (data.dataField == 'EndDate') {
      if (value != null) {
        this.data[this.ToDate.dataField] = value;
        this.DateRange = '';
        localStorage.setItem('dateRange', this.DateRange);
      }
    }
    console.log('data', this.data)
  }

  getStartDate(event: any) {
    let startDate = event.target.value;
    this.StartDate = this.datepipe.transform(startDate, 'dd-MMM-yyyy');
    // this._navService.setStartDate(this.StartDate);
    console.log("Selected Start Date:", this.StartDate);
  }

  getEndDate(event: any) {
    let endDate = event.target.value;
    this.EndDate = this.datepipe.transform(endDate, 'dd-MMM-yyyy');
    // this._navService.setEndDate(this.EndDate);
    console.log("Selected End Date:", this.EndDate);
  }

  ShowHelpMenu() {
    document.addEventListener("keydown", function (zEvent) {
      if (zEvent.key === "F1") {
        zEvent.preventDefault();
        ReportHeaderComponent.that.OpenShortcutKeys(zEvent);
      }
      if (zEvent.key === "Escape") {
        if (ReportHeaderComponent.that.ShortcutKeys) {
        // if (document.body.className.indexOf('ui-widget') !== -1) {
          ReportHeaderComponent.that.CloseShortcutKeys()
          ReportHeaderComponent.that.CloseModal()
          zEvent.preventDefault();
        } else {
          zEvent.preventDefault();
        }
      }
      if (zEvent.key === "F2") {
        ReportHeaderComponent.that.OpenModal(zEvent);
      }
    });
  }

  // prints the page
  GetPrintReport(){
    window.print();
  }

  // sets value of dates and company in localstorage 
  ApplyFilter() {
    localStorage.removeItem('StartDate');
    localStorage.removeItem('EndDate');
    localStorage.setItem('StartDate', this.data.StartDate);
    localStorage.setItem('EndDate', this.data.EndDate);
    console.log('this.data.StartDate', this.data.StartDate, this.data.EndDate)
    var dates: any = [];
    this._navService.setStartDate(this.data.StartDate);
    this._navService.setEndDate(this.data.EndDate);
    
    dates.push(this.data.StartDate);
    dates.push(this.data.EndDate)
    this.CompanyChnage.emit(dates);
    this._navService.changeNav(dates);
    this.CloseModal();
   
    // this.ChnageDefultCompany();
    this.CompanyChnage.emit(this.CompanyIdForCookie);
    this._navService.changeNav(this.CompanyIdForCookie);
  }

  // storing companydetails in localstorage
  ChnageDefultCompany() {
    localStorage.setItem("ChnageCompnayId",JSON.stringify(this.CompanyIdForCookie));
    // this.CompanyChnage.emit(this.CompanyIdForCookie);
    // this._navService.changeNav(this.CompanyIdForCookie);
  }

  // download function
  onReportDownloadClick(){
    this.onReportDownloadClickOutput.emit();
  }

}
